export default {
    'common.more': '展开',
    'common.collapse': '收起',
    'common.noEmpty': '不能为空',
    'common.validator.mobile': '手机号格式错误',
    'common.validator.email': '邮箱格式错误',
    'common.validator.number': '请输入正确数字',
    'common.validator.password': '由数字、字母和下划线组成，{length}个字符以内',
    'common.validator.maxLength': '{length}个字符以内',
    'common.btn.search': '查询',
    'common.btn.reset': '重置',
    'common.btn.refresh': '刷新',
    'common.btn.add': '新增',
    'common.btn.edit': '编辑',
    'common.btn.delete': '删除',
    'common.btn.confirm': '确定',
    'common.btn.cancel': '取消',
    'common.btn.update': '修改',
    'common.btn.yes': '是',
    'common.btn.no': '否',
    'common.btn.look': '查看',
    'common.btn.operate': '操作',
    'common.datePicker.startDate': '开始日期',
    'common.datePicker.endDate': '结束日期',
    'common.input.placeholder': '请输入',
    'common.default.option': '请选择',
    'common.tip': '提示',
    'common.edit.message': '确定修改？',
    'common.success': '成功',
    'common.total.amount': '合计金额',
    'widget.alert.yes': '确认',
    'widget.alert.no': '取消',
    'nav.language': '语言设置',
    'nav.language.select': '请输入您使用的语言',
    'nav.bread.home': '首页',
    'language.zh': '简体中文',
    'language.mx': 'Mexican',
    'language.en': 'English',
    'language.vi': 'Tiếng việt nam',
    'language.id': 'Indonesian',
    'nav.version': '版本信息',
    'version.version': '版本号',
    'version.pushUser': '出品人',
    'version.developer': '开发人',
    'version.releaseTime': '发布时间',
    'version.content': '版本内容',
    'nav.login': '登录',
    'nav.logout': '安全退出',
    'nav.logout.tips': '当前用户将会被注销并回到系统入口',
    'nav.logout.confirm': '确认注销当前用户？',
    'nav.password': '修改密码',
    'nav.session.add': '添加账号',
    'nav.password.old': '旧密码',
    'nav.password.new': '新密码',
    'nav.password.newPasswordConfirm': '确认新密码',
    'nav.password.newPasswordConfirm.error': '两次输入密码不一致',
    'nav.historyback': '返回',
    'nav.brand.text': '资金管理',
    'nav.account.title': '账户管理',
    'nav.account.item.delete': '确定要删除该账户吗？',
    'nav.account.item.confirm.state': '确定要{state}该账户吗？',
    'nav.account.company.subTitle': '资金方',
    'nav.account.company.searchForm.state': '公司状态',
    'nav.account.company.searchForm.stateValue.enable': '启用',
    'nav.account.company.searchForm.stateValue.disable': '禁用',
    'nav.account.company.tableColumn.accountId': '账户Id',
    'nav.account.company.tableColumn.accountName': '账户名称',
    'nav.account.company.tableColumn.currency': '币种',
    'nav.account.company.tableColumn.balance': '账户余额',
    'nav.account.company.tableColumn.cardNumber': '卡号',
    'nav.account.company.tableColumn.bankName': '所属银行',
    'nav.account.company.tableColumn.phone': '预留手机号',
    'nav.account.company.tableColumn.email': 'Email',
    'nav.account.company.tableColumn.createTime': '开户时间',
    'nav.account.company.tableColumn.updateTime': '更新时间',
    'nav.account.company.tableColumn.state': '状态',
    'nav.account.company.tableColumn.operation': '操作',
    'nav.account.company.columnBtn.recharge': '充值',
    'nav.account.company.formData.addTitle': '新增公司账户',
    'nav.account.company.formData.editTitle': '编辑公司账户',
    'nav.account.company.formData.accountName': '账户名称',
    'nav.account.company.formData.currency': '币种',
    'nav.account.company.formData.balance': '金额',
    'nav.account.company.formData.cardNumber': '卡号',
    'nav.account.company.formData.bankName': '银行',
    'nav.account.company.formData.phone': '预留手机号',
    'nav.account.company.formData.email': 'Email',
    'nav.account.company.formData.state': '状态',
    'nav.account.company.formData.error.accountName.required': '账户名称不能为空',
    'nav.account.company.formData.error.currency.required': '币种不能为空',
    'nav.account.company.formData.recharge.title': '充值',
    'nav.account.company.formData.recharge.balance': '账户余额',
    'nav.account.company.formData.recharge.amount': '充值金额',
    'nav.account.company.formData.recharge.amount.required': '充值金额不能为空',
    'nav.account.personal.subTitle': '资产方',
    'nav.account.blacklist.subTitle': '黑名单管理',
    'nav.account.blacklist.pushItem.title': '将以下信息加入黑名单',
    'nav.account.blacklist.TriggerConditions.title': '触发条件',
    'nav.account.blacklist.TriggerConditions.overdueDays.title': '逾期天数 >= ',
    'nav.subjectMatter.title': '贷款管理',
    'nav.subjectMatter.credit': '放款管理',
    'nav.subjectMatter.credit.receipt': '放款单据',
    'nav.subjectMatter.credit.check': '放款审核',
    'nav.subjectMatter.loan': '放款明细',
    'nav.subjectMatter.loan.detail': '还款详情',
    'nav.subjectMatter.repayment': '还款管理',
    'nav.subjectMatter.repayment.unpaid': '还款明细',
    'nav.subjectMatter.repayment.repaid': '已还款',
    'nav.subjectMatter.repayment.detail': '还款详情',
    'nav.subjectMatter.repayment.result': '支付结果',
    'nav.subjectMatter.repayment.penalty': '罚息记录',
    'nav.subjectMatter.cashDetail': '资金明细',
    'nav.subjectMatter.cashDetail.table.clumn.customerId': '客户标识',
    'nav.subjectMatter.cashDetail.table.clumn.cameraId': '进件标识',
    'nav.subjectMatter.cashDetail.table.clumn.amount': '变动金额',
    'nav.subjectMatter.cashDetail.table.clumn.currency': '币种',
    'nav.subjectMatter.cashDetail.table.clumn.payNo': '支付流水号',
    'nav.subjectMatter.cashDetail.table.clumn.fundAction': '资金动作',
    'nav.subjectMatter.cashDetail.table.clumn.fundType': '资金类型',
    'nav.subjectMatter.cashDetail.table.clumn.debit': '加-减',
    'nav.subjectMatter.cashDetail.table.clumn.remark': '备注信息',
    'nav.subjectMatter.cashDetail.table.clumn.createTime': '创建时间',
    'nav.subjectMatter.cashDetail.table.clumn.updateTime': '更新时间',
    'cash.searchForm.cameraId': '订单号',
    'cash.searchForm.accountId': '账户ID',
    'cash.searchForm.fundType': '资金类型',
    'cash.searchForm.debit': '变动类型',
    'cash.tableData.payNo': '流水号',
    'cash.tableData.lid': '账单号',
    'cash.tableData.cameraId': '订单号',
    'cash.tableData.id': '账户ID',
    'cash.tableData.debit': '变动类型',
    'cash.tableData.debit.add': '加',
    'cash.tableData.debit.reduce': '减',
    'cash.tableData.currency': '币种',
    'cash.tableData.amount': '变动金额',
    'cash.tableData.fundType': '资金类型',
    'cash.tableData.fundType.tenant': '租户',
    'cash.tableData.fundType.personal': '个人',
    'cash.tableData.fundType.cash': '提现',
    'cash.tableData.remark': '描述',
    'cash.tableData.remark.income': '收入:',
    'cash.tableData.remark.expenditure': '支出:',
    'cash.tableData.createTime': '创建时间',
    'repayment.unpaid.searchForm.cameraId': '订单号',
    'repayment.unpaid.searchForm.shouldTimeDateValue': '应还日期',
    'repayment.unpaid.searchForm.finishTimeDateValue': '结清时间',
    'repayment.unpaid.searchForm.operateTimeDateValue': '操作时间',
    'repayment.unpaid.searchForm.payState': '状态',
    'repayment.unpaid.searchForm.doubleLoan': '是否复贷客户',
    'repayment.unpaid.searchForm.personalOperate': '本人操作',
    'repayment.unpaid.operation': '贷款操作',
    'repayment.unpaid.operation.manual': '手动核销',
    'repayment.unpaid.operation.partial': '部分还款',
    'repayment.unpaid.operation.substract': '减免',
    'repayment.unpaid.operation.settlement': '正常结清',
    'repayment.unpaid.operation.extends': '展期',
    'repayment.unpaid.view': '查看',
    'repayment.unpaid.view.detail': '查看还款详情',
    'repayment.unpaid.view.result': '查看支付结果',
    'repayment.unpaid.tableData.cameraId': '订单号',
    'repayment.unpaid.tableData.productName': '产品名称',
    'repayment.unpaid.tableData.pauseStatus': '暂停催收',
    'repayment.unpaid.tableData.noPauseStatus': '未暂停催收',
    'repayment.unpaid.tableData.pauseRemark': '备注',
    'repayment.unpaid.tableData.dialog.title.pasuse': '账单暂停催收',
    'repayment.unpaid.tableData.dialog.title.resume': '账单解除暂停催收',
    'repayment.unpaid.tableData.dialog.hint.pause': '请输入暂停备注',
    'repayment.unpaid.tableData.dialog.hint.resume': '请输入解除暂停备注',
    'repayment.unpaid.tableData.dialog.btn.cancel': '取消',
    'repayment.unpaid.tableData.dialog.btn.pause': '暂停',
    'repayment.unpaid.tableData.dialog.btn.resume': '解除暂停',
    'repayment.unpaid.tableData.customerName': '姓名',
    'repayment.unpaid.tableData.indexs': '期次',
    'repayment.unpaid.tableData.shouldCapital': '应还本金',
    'repayment.unpaid.tableData.factCapital': '实还本金',
    'repayment.unpaid.tableData.shouldInterest': '应还利息',
    'repayment.unpaid.tableData.factInterest': '实还利息',
    'repayment.unpaid.tableData.shouldFine': '应还罚息',
    'repayment.unpaid.tableData.factFine': '实还罚息',
    'repayment.unpaid.tableData.shouldOtherTotalFee': '应还管理费',
    'repayment.unpaid.tableData.factOtherTotalFee': '实还管理费',
    'repayment.unpaid.tableData.shouldOverdueFee': '应还违约金',
    'repayment.unpaid.tableData.factOverdueFee': '实还违约金',
    'repayment.unpaid.tableData.subtractAmount': '减免总额',
    'repayment.unpaid.tableData.shouldTime': '应还时间',
    'repayment.unpaid.tableData.finishTime': '结清时间',
    'repayment.unpaid.tableData.isExtends': '是否展期',
    'repayment.unpaid.tableData.doubleLoan': '是否复贷客户',
    'repayment.unpaid.tableData.updateTime': '操作时间',
    'repayment.unpaid.tableData.updateUser': '操作人',
    'repayment.unpaid.specialviet.form.title': '还款',
    'repayment.unpaid.specialviet.form.totalAmount': '应还总额',
    'repayment.unpaid.specialviet.form.paidAmount': '本次还款金额',
    'repayment.unpaid.specialviet.form.capitalAmount': '本次还款本金',
    'repayment.unpaid.specialviet.form.interestAmount': '本次还款利息',
    'repayment.unpaid.specialviet.form.penaltyAmount': '本次还款罚息',
    'repayment.unpaid.specialviet.form.unpaidAmount': '剩余未还金额',
    'repayment.unpaid.specialviet.form.factTime.required': '实际还款时间不能为空',
    'repayment.unpaid.specialviet.form.timestatus.label': '到账时间＞客户实际还款时间，需减去额外罚',
    'repayment.unpaid.manualDialog.title': '手动核销操作',
    'repayment.unpaid.manualDialog.partPaymentData.unpaidAmount': '剩余未还总额',
    'repayment.unpaid.manualDialog.partPaymentData.capitalAmount': '剩余未还本金',
    'repayment.unpaid.manualDialog.partPaymentData.interestAmount': '剩余未还利息',
    'repayment.unpaid.manualDialog.partPaymentData.paidAmount': '本次还款金额',
    'repayment.unpaid.manualDialog.partPaymentData.writeOffAmount': '本次核销金额',
    'repayment.unpaid.manualDialog.manualRules.paidAmount.required': '本次还款金额不能为空',
    'repayment.unpaid.manualDialog.onManualPaidSubmit.success': '核销成功',
    'repayment.unpaid.manualDialog.onPartialPaidSubmit.success': '还款成功',
    'repayment.unpaid.extendsDialog.onExtendsPaidSubmit.success': '展期成功',
    'repayment.unpaid.partialDialog.title': '部分还款操作',
    'repayment.unpaid.partialDialog.htitle1': '当前未还金额',
    'repayment.unpaid.partialDialog.htitle2': '还款试算',
    'repayment.unpaid.partialDialog.htitle3': '实际还款时间',
    'repayment.unpaid.partialDialog.remark': '备注',
    'repayment.unpaid.partialDialog.unpaidData.paidAmount': '已还合计',
    'repayment.unpaid.partialDialog.unpaidData.unpaidAmount': '未还合计',
    'repayment.unpaid.partialDialog.unpaidData.capitalAmount': '未还本金',
    'repayment.unpaid.partialDialog.unpaidData.interestAmount': '未还利息',
    'repayment.unpaid.partialDialog.unpaidData.penaltyAmount': '未还罚息',
    'repayment.unpaid.partialDialog.unpaidData.feesAmount': '未还管理费',
    'repayment.unpaid.partialDialog.calculateData.inputAmount': '本次还款金额',
    'repayment.unpaid.partialDialog.calculateData.trialCalculation': '试算',
    'repayment.unpaid.partialDialog.calculateData.unpaidAmount': '试还合计',
    'repayment.unpaid.partialDialog.calculateData.capitalAmount': '试还本金',
    'repayment.unpaid.partialDialog.calculateData.interestAmount': '试还利息',
    'repayment.unpaid.partialDialog.calculateData.penaltyAmount': '试还罚息',
    'repayment.unpaid.partialDialog.calculateData.feesAmount': '试还管理费',
    'repayment.unpaid.partialDialog.calcPartRepaymentHandler.notNumber': '输入不是数字',
    'repayment.unpaid.partialDialog.calcPartRepaymentHandler.validNumber': '还款金额不能为空或者小于等于0',
    'repayment.unpaid.partialDialog.onPartailPaidSubmit.confirm': '本次还款金额为{inputAmount}, 是否继续?',
    'repayment.unpaid.substractDialog.title': '减免操作',
    'repayment.unpaid.substractDialog.htitle2': '减免试算',
    'repayment.unpaid.substractDialog.htitle3':'逾期天数减免',
    'repayment.unpaid.partialDialog.unpaidData.overdueDays':'逾期天数',
    'repayment.unpaid.substractDialog.calculateData.inputAmount': '本次减免金额',
    'repayment.unpaid.substractDialog.calculateData.unpaidAmount': '减免合计',
    'repayment.unpaid.substractDialog.calculateData.capitalAmount': '减免本金',
    'repayment.unpaid.substractDialog.calculateData.interestAmount': '减免利息',
    'repayment.unpaid.substractDialog.calculateData.penaltyAmount': '减免罚息',
    'repayment.unpaid.substractDialog.calculateData.feesAmount': '减免管理费',
    'repayment.unpaid.substractDialog.onPartailPaidSubmit.confirm': '本次减免金额为{inputAmount}, 是否继续?',

    'repayment.unpaid.substractDialog.calculateData.inputDays': '本次减免天数',

    'repayment.unpaid.settlementDialog.title': '正常结清操作',
    'repayment.unpaid.extendsDialog.title': '展期',
    'repayment.unpaid.extendsDialog.htitle1': '展期金额确认',
    'repayment.unpaid.extendsDialog.unpaidData.extendsAmount': '展期金额',
    'repayment.unpaid.extendsDialog.unpaidData.extendsFee': '未还展期管理费',
    'repayment.unpaidDetail.title.repaidDetail': '待还详情',
    'repayment.unpaidDetail.title.repaidRecord': '还款记录',
    'repayment.unpaidDetail.title.substractRecord': '减免记录',
    'repayment.unpaidDetail.detailList.totalAmount': '应还金额',
    'repayment.unpaidDetail.detailList.couponAmount': '优惠券减免金额',
    'repayment.unpaidDetail.detailList.paidAmount': '已还金额',
    'repayment.unpaidDetail.detailList.unpaidAmount': '剩余应还总额',
    'repayment.unpaidDetail.detailList.capitalAmount': '剩余本金',
    'repayment.unpaidDetail.detailList.interestAmount': '剩余利息',
    'repayment.unpaidDetail.detailList.penaltyAmount': '剩余罚息',
    'repayment.unpaidDetail.detailList.feesAmount': '其他费用',
    'repayment.unpaidDetail.detailList.shouldOverdueFee':'催收费',
    'repayment.unpaidDetail.recordList.id': '还款流水号',
    'repayment.unpaidDetail.recordList.factTime': '实收时间',
    'repayment.unpaidDetail.recordList.factAmount': '实收金额',
    'repayment.unpaidDetail.recordList.factCapital': '实收本金',
    'repayment.unpaidDetail.recordList.factInterest': '实收利息',
    'repayment.unpaidDetail.recordList.factFine': '实收罚息',
    'repayment.unpaidDetail.recordList.factFeeAmount': '其他费用',
    'repayment.unpaidDetail.recordList.remark': '备注',
    'repayment.unpaidDetail.recordList.updateRemark': '修改还款备注',
    'repayment.unpaidDetail.recordList.updateRemark.success': '修改成功',
    'repayment.unpaidDetail.substractList.operator': '操作人',
    'repayment.unpaidDetail.substractList.factTime': '减免时间',
    'repayment.unpaidDetail.substractList.factAmount': '减免总额',
    'repayment.unpaidDetail.substractList.factCapital': '减免本金',
    'repayment.unpaidDetail.substractList.factInterest': '减免利息',
    'repayment.unpaidDetail.substractList.factFine': '减免罚息',
    'repayment.unpaidDetail.substractList.factFeeAmount': '减免其他费用',
    'repayment.unpaidDetail.substractList.remark': '备注',
    'repayment.unpaidDetail.lastIndex': '上一期',
    'repayment.unpaidDetail.nextIndex': '下一期',
    'repayment.penalty.searchForm.cameraId': '订单号',
    'repayment.penalty.searchForm.shouldTimeDateValue': '应还日期',
    'repayment.penalty.tableData.cameraId': '订单号',
    'repayment.penalty.tableData.productName': '产品名称',
    'repayment.penalty.tableData.customerName': '姓名',
    'repayment.penalty.tableData.indexs': '期次',
    'repayment.penalty.tableData.shouldFine': '累计罚息',
    'repayment.penalty.tableData.factFine': '实还罚息',
    'repayment.penalty.tableData.state': '状态',
    'repayment.penalty.tableData.shouldTime': '应还时间',
    'repayment.penalty.view': '查看',
    'repayment.doubleLoan.first': '否',
    'repayment.doubleLoan.double': '是',
    'repayment.personalOperate.self': 'Self',
    'repayment.personalOperate.all': 'All',
    'repayment.penalty.operation': '操作',
    'loan.searchForm.cameraId': '订单号',
    'loan.searchForm.cardNo': '证件号',
    'loan.searchForm.state': '状态',
    'loan.searchForm.releaseTime': '放款时间',
    'loan.searchForm.customerName': '姓名',
    'loan.searchForm.phone': '手机号',
    'loan.tableData.cameraId': '订单号',
    'loan.tableData.productName': '产品名称',
    'loan.tableData.customerName': '姓名',
    'loan.tableData.contractAmount': '贷款合同金额',
    'loan.tableData.amount': '放款金额',
    'loan.tableData.interest': '总利息',
    'loan.tableData.feeAmount': '管理费',
    'loan.tableData.loanCycle': '期限',
    'loan.tableData.rate': '利率',
    'loan.tableData.state': '状态',
    'loan.tableData.createTime': '信审终审时间',
    'loan.tableData.loanCreateTime': '创建时间',
    'loan.tableData.reviewTime': '审核时间',
    'loan.tableData.releaseTime': '放款时间',
    'loan.tableData.operation': '操作',
    'loan.tableData.cancelLoan': '取消借款',
    'loan.tableData.view': '查看还款计划',
    'loan.tableData.viewRepayment': '查看还款详情',
    'loan.tableData.loanState.init': '待审核',
    'loan.tableData.loanState.lending': '已放款',
    'loan.tableData.loanState.finish': '已结清',
    'loan.tableData.loanState.writeoff': '核销',
    'loan.tableData.loanState.cancel': '取消',
    'loan.tableData.loanState.fail': '放款失败',
    'loan.tableData.loanState.refuse': '审核拒绝',
    'loan.tableData.loanState.transaction': '放款中',
    'loan.tableData.rateType.day': '日息{rate}%',
    'loan.tableData.rateType.month': '月息{rate}%',
    'loan.tableData.rateType.year': '年息{rate}%',
    'loan.tableData.loanCycleUnit.day': '{loanCycle}天',
    'loan.tableData.loanCycleUnit.month': '{loanCycle}个月',
    'loan.confirm.cancelLoan': '确定要退标吗?',
    'loan.cancelLoan.success': '取消成功!',
    'loandetail.tableData.id': 'ID',
    'loandetail.tableData.productName': '产品名称',
    'loandetail.tableData.customerName': '姓名',
    'loandetail.tableData.indexs': '期次',
    'loandetail.tableData.shouldCapital': '应还本金',
    'loandetail.tableData.factCapital': '实还本金',
    'loandetail.tableData.shouldInterest': '应还利息',
    'loandetail.tableData.factInterest': '实还利息',
    'loandetail.tableData.shouldFine': '应还罚息',
    'loandetail.tableData.factFine': '实还罚息',
    'loandetail.tableData.shouldOtherTotalFee': '应还管理费',
    'loandetail.tableData.factOtherTotalFee': '实还管理费',
    'loandetail.tableData.shouldOverdueFee': '应还违约金',
    'loandetail.tableData.factOverdueFee': '实还违约金',
    'loandetail.tableData.shouldTime': '应还时间',
    'loandetail.tableData.factTime': '实收时间',
    'loandetail.tableData.view': '查看',
    'credit.check.tableData.bankName': '银行名称',
    'credit.check.tableData.bankCard': '银行卡号',
    'credit.check.tableData.phone': '手机号',
    'credit.check.tableData.cardNo': '证件号',
    'credit.check.aciton.view': '查看',
    'credit.check.aciton.check': '审核',
    'credit.check.button.reject': '拒绝',
    'credit.check.button.approve': '同意',
    'credit.check.button.batchReview': '批量审核',
    'credit.check.dialog.remark': '备注',
    'credit.check.dialog.rejected': '已拒绝',
    'credit.check.dialog.approved': '已同意',
    'repayment.state.repaid': '已还款',
    'repayment.state.unpaid': '未还款',
    'repayment.state.normal': '正常还款',
    'repayment.state.overdue': '逾期',
    'repayment.state.afterOverdue': '逾期后还款',
    'repayment.state.partial': '部分还款',
    'repayment.state.afterPartial': '部分还款后结清',
    'repayment.state.manual': '手动核销',
    'repayment.state.cancel': '取消',
    'repayment.isExtends.notExtends': '未展期',
    'repayment.isExtends.extending': '展期中',
    'repayment.isExtends.extends': '已展期',
    // 催收核销
    'repayment.hx.status': '状态',
    'repayment.hx.overrideType': '核销类型',
    'repayment.hx.orderNumber': '订单号',
    'repayment.hx.repaymentAmount': '还款金额',
    'repayment.hx.createTime': '创建时间',
    'repayment.hx.updateTime': '更新时间',
    'repayment.hx.createUserName': '创建人',
    'repayment.hx.updateUserName': '更新人',
    'repayment.hx.viewCredentials': '查看凭证',
    'repayment.hx.operating': '操作',
    'repayment.hx.manualOverride': '手动核销',
    'repayment.hx.partialRepayment': '部分还款',
    'repayment.hx.normalSettlement': '正常结清',
    'repayment.hx.cancel': '取消',
    'repayment.tallyBillState.waitApprove': '待审核',
    'repayment.tallyBillState.finishApprove': '核销完成',
    'repayment.tallyBillState.cancelApprove': '已取消',
    'repayment.tallyBillType.inbursaRepay': '使用INBURSA还款',
    'repayment.tallyBillType.overdueRepay': '用户长期逾期后还款核销',
    'repayment.hx.noVoucherUpload': '当前单据未上传凭证',
    'repayment.hx.stateNotSupportOperation': '当前状态不支持操作',
    'repayment.hx.cancelSuccess': '取消成功',
    'repayment.hx.sureCancel': '确认取消吗',
    'repayment.hx.cancelFailed': '取消失败，请检查',
    'nav.subjectMatter.repayment.hx': '催收核销管理',
    /** 支付管理 */
    'common.isDelete': '是否删除?',
    'status.NameNoNull': '状态不能为空',
    'sync.member': '同步会员信息',
    'typeList.filter.time': '创建时间',
    'outcome.amount': '金额',
    'callRecord.filter.serialId': '流水号',
    'serviceFee.userId': '用户ID',
    'merchant.scenario': '场景',
    'icon.copy': '复制',
    'notice.StatusNoNull': '通知状态不能为空', // noticeStatusNoNull
    'payType.name': '支付类型', // payType
    'payType.NoNull': '支付类型不能为空', // payTypeNoNull
    'merchant.StatusNoNull': '租户不能为空', // merchantStatusNoNull
    'pri.NoNull': '排序不能为空', // priNoNull
    'batch.add': '批量添加',
    'bank.id': '银行ID',
    'bank.name': '银行名称',
    'bank.icon': '图标',
    'bank.tel': '联系电话',
    'bank.website': '官网网址',
    'bank.promptMsg': '提示文案',
    'bank.payType': '支付方式',
    'bank.status': '状态', // status
    'bank.disable': '停用',
    'bank.enable': '启用',
    'bank.addDialogTitle': '添加银行',
    'bank.invalid': '无效', // invalid
    'bank.effective': '有效', // effective
    'bank.isBatchEnable': '是否启用?',
    'bank.isBatchDisable': '是否停用?',
    'bank.title': '银行', // bank
    'bank.config': '租户银行配置', // bankConfig
    'bank.tenant': '租户', // tenant
    'bank.merchantNoNull': '租户不能为空',
    'bank.NoNull': '银行不能为空',
    'bank.thridName': '三方名称',
    'bank.thridBankNameNoNull': '三方名称不能为空', // thridBankNameNoNull
    'bankCardManage.userId': '用户id',
    'bankCardManage.userName': '姓名',
    'bankCardManage.realName': '全名',
    'bankCardManage.firstName': '名',
    'bankCardManage.lastName': '姓',
    'bankCardManage.expirationYear': '有效期年',
    'bankCardManage.expirationMonth': '有效期月',
    'bankCardManage.cvv2': '信用卡安全码',
    'bankCardManage.tel': '手机号',
    'bankCardManage.IDCard': '证件号码',
    'bankCardManage.idType': '证件类型',
    'bankCardManage.cardNum': '卡号',
    'bankCardManage.oprType': '放款类型',
    'bankCardManage.cardType': '卡类型',
    'bankCardManage.email': '邮箱',
    'bankCardManage.bankName': '银行名称',
    'bankCardManage.bankId': '银行Id',
    'bankCardManage.status': '状态',
    'bankCardManage.createTime': '创建时间',
    'bankCardManage.merchantId': '租户Id',
    'bankCardManage.addDialogTitle': '添加用户银行卡管理',
    'bankCardManage.normal': '正常',
    'bankCardManage.enable': '启用',
    'bankCardManage.notenable': '未启用',
    'bankCardManage.disable': '冻结',
    'bankCardManage.identityType': '身份证',
    'bankCardManage.debitCard': '借记卡',
    'bankCardManage.creditCard': '信用卡',
    'bankCardManage.semiCreditCard': '准贷记卡',
    'bankCardManage.prepaidCard': '预付费卡',
    'bankCardManage.valid': '是否验证',
    'bankCardManage.notCheck': '未验证',
    'bankCardManage.passedCheck': '验证通过',
    'bankCardManage.failededCheck': '验证失败',
    'bankCardManage.checking': '验证中',
    'bankCardManage.cardNumNoNull': '卡号不能为空',
    'bankCardManage.identityNoNull': '证件号码不能为空',
    'bankCardManage.merchantIdNoNull': '租户Id不能为空',
    'bankCardManage.bankIdNoNull': '银行Id不能为空',
    'bankCardManage.isBatchDisable': '是否冻结?',
    'bankCardManage.ifscCode': 'IFSCCode',
    'returnCode.channelNoNull': '请选择渠道',
    'returnCode.paymentTypeNoNull': '请选择支付类型',
    'returnCode.name': '返回码', // returnCode
    'returnCode.returnMsg': '返回信息',
    'sales.failCount': '放款失败次数',
    'sales.note': '备注',
    'sales.documentsState': '单据状态',
    'sales.updateTime': '更新时间',
    'sales.operation': '操作',
    'sales.generateScreenshot': '获取截图',
    'sales.download': '下载',
    'sales.toast': '生成失败..数据存在空值',
    'sales.documentsNo': '收款单据号',
    'sales.realName': '真实姓名',
    'sales.bankCardNo': '银行卡号',
    'repay.add': '新增',
    'repay.reviewed': '已审核',
    'repay.doing': '处理中',
    'repay.completed': '已完成',
    'repay.refused': '已拒绝',
    'repay.paying': '付款中',
    'repay.pending': '待处理',
    'repay.paymentSuccess': '付款成功',
    'repay.paymentFail': '付款失败',
    'repay.abnormal': '异常',
    'statusType.submitted': '提交',
    'statusType.pending': '待定',
    'statusType.processing': '处理中',
    'statusType.completed': '完成',
    'statusType.error': '错误',
    'bank.bankNameNoNull': '银行名称不能为空',
    'bank.realNameCannot be empty': '全名不能为空',
    'bank.phoneNoNull': '联系电话不能为空',
    'lending.FinancialCodeExpired': '财务码过期',
    'lending.HasBeenCancelled': '已取消',
    'chargeback.add': '新增',
    'chargeback.deducting': '扣款中',
    'chargeback.completeOfPart': '部分完成',
    'chargeback.closed': '已关闭',
    'chargeback.allCpmplete': '全部完成',
    'chargeback.expireDate': '已过期',
    'chargeback.exception': '异常',
    'deduct.DocumentStatus': '单据状态',
    'deduct.RepaymentCode': '还款码',
    'deduct.RepaymentPeriodTime': '还款期次',
    'deduct.ShouldAlsoAmount': '应还总额',
    'deduct.RepayAmount': '还款金额',
    'deduct.ActualAmount': '实还金额',
    'deduct.expireDate': '过期时间',
    'deduct.createTime': '创建时间',
    'deduct.realAmount': '实际金额',
    'deduct.purchaseCurrency': '用户还款币种',
    'Generate return code': '生成还款码',
    'Repayment code': '还款码方式',
    'Repayment trial': '还款试算',
    'Try to pay back the principal': '试还本金',
    'Try to pay interest': '试还利息',
    'Try to pay a penalty': '试还罚息',
    'Trial management fee': '试还管理费',
    'Trial total': '试还总额',
    'Repayment channel': '还款渠道',
    'repayment.merge.generate': '生成还款码（{count}）',
    'repayment.merge.selectedPlans': '已选还款计划',
    'repayment.merge.shouldTime': '应还时间',
    'repayment.merge.unpaidAmount': '待还金额',
    'repayment.merge.overdueFee': '试还违约金',
    'repayment.merge.openLink': '打开还款链接',
    'repayment.merge.previewFailed': '合并还款试算失败',
    'repayment.merge.invalidState': '只能选择未还款、逾期或部分还款的账单',
    'repayment.merge.sameMainBillRequired': '只能合并同一主账单的还款计划',
    'channel.loanDocuments': '放款单据',
    'channel.orderNo': '订单号',
    'channel.outcomeId': '放款单据号',
    'channel.oanApplicationDate': '放款申请日期',
    'channel.loanAmount': '放款金额',
    'channel.loanTime': '实际放款时间',
    'channel.pleaseEnterTheLoanTime': '请选择放款时间',
    'channel.lendingDate': '实际放款日期',
    'channel.lendingApplyDate': '放款申请日期',
    'channel.payingDate': '实际还款时间',
    'channel.name': '姓名',
    'channel.idNo': '证件号',
    'channel.bvn': 'BVN',
    'channel.payStatus': '支付状态',
    'channel.bankCardType': '银行卡类型',
    'channel.confirmTheLoan': '确认放款',
    'channel.lendingAgain': '重新放款',
    'channel.cancelLending': '取消放款',
    'channel.Invalid': '失效',
    'channel.isConfirmTheLoan': '是否确认放款?',
    'channel.isConfirmTheLoanFailure': '是否确认放款失败?',
    'channel.isLoanSuccess': '是否确认放款成功?',
    'channel.isConfirmLendingAgain': '是否确认重新放款?',
    'channel.isConfirmCancelLending': '是否确认取消放款?',
    'channel.loanSuccess': '放款成功',
    'channel.loanSuccessBatch': '批量放款成功',
    'channel.manualLending': '手动放款',
    'channel.systemLending': '系统放款',
    'channel.loanFailure': '放款失败',
    'channel.loanExport': '导出',
    'channel.notPaying': '未付款',
    'channel.changeOprType': '变更放款类型',
    'channel.isConfirmChangeOprType': '是否确认变更放款类型?',
    'channel.businessParam': '是否复贷客户',
    'channel.firstLoan': '否',
    'channel.doubleLoan': '是',
    'channel.channel': '渠道',
    'channel.bankCoding': '银行编码',
    'channel.NoNull': '渠道不能为空', // channelNoNull
    'channel.threePartiesMerchantNumber': '三方商户号',
    'channel.merchantNoNull': '三方商户号不能为空',
    'channel.channelName': '渠道名称',
    'channel.channelID': '渠道ID',
    'channel.channelNumber': '渠道编号',
    'channel.createTime': '创建时间',
    'channel.theTemporaryClosureOfOpenTime': '临时关闭开启时间',
    'channel.theTemporaryClosureOfTheEndOfTime': '临时关闭结束时间',
    'channel.rule.channelID': '由数字、字母和下划线组成，20个字符以内',
    'channel.rule.channelName': '规则名称20个字符以内',
    'channel.rule.channelNumber': '100个字符以内',
    'routing.sorting': '排序', // sorting
    'routing.weight': '权重',
    'routing.weightRequired': '权重不能为空',
    'routing.weightInvalid': '权重必须为不小于0的整数',
    'routing.singleLimit': '单笔限额',
    'routing.singleMinimumLimit': '单笔最小限额',
    'routing.dailyLimit': '单日限额',
    'routing.monthlyAllowance': '单月限额',
    'routing.theTemporaryClosureOfInformation': '临时关闭信息',
    'routing.basicInformation': '基础信息',
    'routing.lendingDetail': '放款支付详情', // 需要翻译
    'routing.repaymentDetail': '还款支付详情', // 需要翻译
    'routing.pauseCollection': '暂停催收',
    'routing.resumeCollection': '解除暂停催收',
    'payment.sourceMerchantId': '源租户ID',
    'payment.targetMerchantId': '目标租户ID',
    'base.three.part.config': '三方参数配置',
    'base.three.part.config.type': '支付类型',
    'base.three.part.config.channel': '渠道',
    'base.three.part.config.add': '批量新增',
    'base.three.part.config.delete': '删除',
    'base.three.part.config.modify': '修改',
    'base.three.part.config.id': '参数主键',
    'base.three.part.config.channel.id': '渠道ID',
    'base.three.part.config.channel.name': '渠道名称',
    'base.three.part.config.payment.type': '支付类型',
    'base.three.part.config.payment.desc': '支付类型描述',
    'base.three.part.config.key': '键',
    'base.three.part.config.value': '值',
    'base.three.part.rules.key': '请输入键',
    'nav.bank.bankcard.title': '用户银行卡',
    'nav.bank.title': '银行卡',
    'nav.receipt.title': '单据管理',
    'nav.receipt.lending.title': '放款单据',
    'nav.receipt.lending.detail.title': '放款详情',
    'nav.receipt.repayment.title': '还款单据',
    'nav.receipt.repayment.detail.title': '还款详情',
    'nav.routing.title': '路由配置',
    'nav.routing.lending.title': '放款路由',
    'nav.routing.repayment.title': '还款路由',
    'nav.channel.title': '渠道配置',
    'nav.channel.compare.title': '渠道和银行',
    'nav.channel.threepart.title': '渠道参数',
    'nav.channel.channel.title': '渠道列表',
    'nav.channel.merchant.title': '租户配置',
    'nav.channel.bank.title': '租户和银行',
    'nav.documents.title': '招领单据',
    'documents.user': '还款人',
    'documents.transDate': '还款到账时间',
    'documents.importDate': '导入时间',
    'documents.bindDate': '绑定时间',
    'documents.borrower': '借款人',
    'documents.phone': '手机号',
    'documents.status': '单据状态',
    'documents.operator': '操作人',
    'documents.number': '单据号',
    'documents.amount': '还款金额',
    'documents.createDate': '还款创建时间',
    'documents.ShouldAlsoAmount': '应还总额',
    'documents.releaseTime': '放款时间',
    'documents.shouldTime': '应还时间',
    'documents.download': '下载模板',
    'documents.import': '导入',
    'documents.import.result': '导入结果',
    'documents.import.drag': '将文件拖到此处，或',
    'documents.import.click': '点击上传',
    'documents.import.tip.maxsize': '只能上传xlsx文件，且不超过',
    'documents.import.type.excel': '不是Excel文件',
    'documents.import.size.excel': '文件大小不能超过{size}M',
    'documents.import.exceed': '超出文件上传个数',
    'documents.bind': '已绑定',
    'documents.unbound': '未绑定',
    'documents.amount.all': '汇总金额',
    'nav.borrow.title': '出借管理',
    'nav.borrow.personal.title': '个人出借信息',
    'nav.borrow.company.title': '出借信息',
    'borrow.digisignRegisterStatus': 'Status pendaftaran DigiSign',
    'borrow.digisignRegisterMsg': 'Informasi pendaftaran DigiSign',
    'borrow.digisignActiveStatus': 'Status aktivasi DigiSign',
    'borrow.rdlStatus': 'Status pembukaan akun RDL',
    'borrow.mobile': '手机号',
    'borrow.email': '用户邮箱',
    'borrow.userName': 'Nama Lengkap',
    'borrow.noktp': 'Nomor KTP',
    'borrow.permanentAddress': 'Tempat lahir',
    'borrow.birthday': 'Tanggal lahir',
    'borrow.sex': 'Jenis Kelamin',
    'borrow.nationality': 'Kewarganegaraan',
    'borrow.province': '省份',
    'borrow.city': 'Kota',
    'borrow.street': 'Kecamatan',
    'borrow.community': 'Kelurahan',
    'borrow.postcode': 'Kode Pos',
    'borrow.education': 'Pendidikan Terakhir',
    'borrow.religion': 'Agama',
    'borrow.jobCode': 'Pekerjaan',
    'borrow.address': 'Alamat Lengkap',
    'borrow.industry': 'Bidang Pekerjaan',
    'borrow.rdlAccount': 'RDL ACCOUNT',
    'borrow.userCode': '用户编号',
    'borrow.legalEntityTypeStr': '实体类型',
    'borrow.legalEntityName': '实体名称',
    'borrow.legalEntityId': '实体ID',
    'borrow.workField': '工作行业',
    'borrow.npwpNum': '税号',
    'borrow.statusStr': '状态',
    'borrow.audit.title': '审核信息',
    'borrow.company.image.title': '公司图片',
    'borrow.other.information.title': '其他信息',
//新增页面放款、还款、运营报表
    'loan.searchForm.repayDateTime': '应还时间',
    'nav.account.company.searchForm.customType': '客户类型',
    'nav.account.company.searchForm.stateValue.AllLoan': '所有客户',
    'nav.account.company.searchForm.stateValue.firstLoan': '首贷',
    'nav.account.company.searchForm.stateValue.secondLoan': '复贷',

    'nav.account.company.tableColumn.releaseDate': '放款日期',
    'nav.account.company.tableColumn.releaseCount': '放款笔数',
    'nav.account.company.tableColumn.releaseAmount': '放款金额',
    'nav.account.company.tableColumn.firstLoanCount': '首借人数',
    'nav.account.company.tableColumn.firstLoanMoney': '首借金额',
    'nav.account.company.tableColumn.secondNewPeople': '次新人数',
    'nav.account.company.tableColumn.secondNewMoney': '次新金额',
    'nav.account.company.tableColumn.renewNumber': '续借人数',
    'nav.account.company.tableColumn.renewMoney': '续借金额',
    'nav.account.company.tableColumn.totalFee': '总和费用',

    'nav.account.company.tableColumn.repaymentDate': '应还时间',
    'nav.account.company.tableColumn.repayOrder': '应还订单',
    'nav.account.company.tableColumn.preRepay': '提前还款',
    'nav.account.company.tableColumn.normalRepay': '正常还款',
    'nav.account.company.tableColumn.renewalNumber': '续期笔数',
    'nav.account.company.tableColumn.overdueRepay': '逾期已还',
    'nav.account.company.tableColumn.overduing': '逾期中',
    'nav.account.company.tableColumn.badDebt': '坏账',
    'nav.account.company.tableColumn.repayMoeny': '应还金额',
    'nav.account.company.tableColumn.realityMoney': '实还金额',
    'nav.account.company.tableColumn.overdueFee': '逾期费',
    'nav.account.company.tableColumn.descentMoney': '减免金额',
    'nav.account.company.tableColumn.waitRepayAmount': '待还金额',
    'nav.account.company.tableColumn.preRepayRate': '提前还款率',
    'nav.account.company.tableColumn.normalRepayRate': '正常还款率',
    'nav.account.company.tableColumn.totalRepaymentRate': '总还款率',
    'nav.account.company.tableColumn.firstOverdueRate': '首逾率',
    'nav.account.company.tableColumn.overdueRate': '逾期率',
    'nav.account.company.tableColumn.overdueDay1': 'D1',
    'nav.account.company.tableColumn.overdueDay3': 'D3',
    'nav.account.company.tableColumn.overdueDay5': 'D5',
    'nav.account.company.tableColumn.overdueDay7': 'D7',
    'nav.account.company.tableColumn.overdueDay15': 'D15',
    'nav.account.company.tableColumn.overdueDay30': 'D30',
    'nav.report.title':'交易报表',
    'nav.report.title.loan':'放款报表',
    'nav.report.title.repayment':'还款报表',

    'nav.report.tableColumn.dateTime':'日期',
    'nav.report.tableColumn.customType':'客户类型',
    'nav.report.tableColumn.verifyCount':'审批通过个数',
    'nav.report.tableColumn.releaseCount':'放款成功个数',
    'nav.report.tableColumn.releaseContractAmount':'放款成功合同金额',
    'nav.report.tableColumn.releaseFactAmount':'放款成功实际金额',
    'nav.report.tableColumn.firstOverdueRate':'首逾率',
    'nav.report.tableColumn.expireRepaymentAmount':'回收到期案件合同金额',
    'nav.report.tableColumn.overdueRepaymentAmount':'回收逾期案件合同金额',
    'nav.report.tableColumn.doubleLoanInThreeDaysRate':'3天内复借率',
    'nav.report.tableColumn.firstLoan':'新客',
    'nav.report.tableColumn.doubleLoan':'老客',
    'nav.report.title.daily':'每日运营',
}
